export {};

let splide: any = null;
let currentIndex = 0;
let excludeIds: Array<number> = [];

document.addEventListener('started-user', () => {
    if (!app.user.subscriptionGuard()) {
        return;
    }

    const splideEl = app.html.q('.vertical-videos .splide') as HTMLElement;
    if (!splideEl || typeof Splide === 'undefined') {
        return;
    }

    excludeIds = JSON.parse(app.html.getData(splideEl, 'excludeIds') || '[]');
    const currentVideoId = Number(app.html.getData('.video-slide', 'id'));
    if (currentVideoId && !excludeIds.includes(currentVideoId)) {
        excludeIds.push(currentVideoId);
    }

    splide = new Splide(splideEl);

    splide.on('moved', onSlideMoved);
    splide.on('mounted', onMounted);
    splide.mount();

    document.addEventListener('keydown', onKeydown);
});

document.addEventListener('started-guest', () => {
    app.user.subscriptionGuard();
});

function onSlideMoved(newIndex: number): void {
    if (!splide || newIndex === currentIndex) {
        return;
    }

    const slide = splide.Components.Slides.getAt(newIndex);
    if (!slide) {
        return;
    }

    const allSlides = splide.length;
    currentIndex = newIndex;

    app.verticalVideo.playSlide(slide.slide);
    app.verticalVideo.handleArrows(newIndex, allSlides);

    if (newIndex > allSlides - 3) {
        loadMoreSlides();
    }
}

function playFirstSlide(): void {
    const slide = splide?.Components.Slides.getAt(0);
    if (!slide) {
        return;
    }

    app.verticalVideo.playSlide(slide.slide);
}

function onMounted(): void {
    playFirstSlide();

    if (splide.length < 2) {
        loadMoreSlides();
    }
}

function loadMoreSlides(): void {
    app.verticalVideo.loadMoreSlides(excludeIds)
        .then(slides => {
            if (!slides?.length) {
                return;
            }

            splide.add(slides);
            app.verticalVideo.handleArrows(currentIndex, splide.length);
        });
}

function onKeydown(e: KeyboardEvent): void {
    if (e.key === 'ArrowDown') {
        nextSlide();
    }

    if (e.key === 'ArrowUp') {
        prevSlide();
    }
}

function nextSlide(): void {
    splide?.go('+1');
}

function prevSlide(): void {
    splide?.go('-1');
}

window.nextSlide = nextSlide;
window.prevSlide = prevSlide;
